const firstLattersReg = /^0{2}\d+$/;

function format(input, currency) {
  let value = input.deleteSpaces();

  value = deleteIfNotAllowed(value, currency.significant_zeros);
  value = value.replace(/,/g, '.');

  // TODO: @danealton временно решения, для криптовалют не используем разбиение на разряды,
  // потому что работает некорректно - разбиение на разряды происходит для цифр после запятой
  if (currency.significant_zeros > 2) {
    return value;
  }

  return addThousandSeparator(value, ' ');
}

function deleteIfNotAllowed(value, decimals = 2) {
  if (isAllowed(value, decimals)) return value;

  value = value.slice(0, -1);

  return deleteIfNotAllowed(value, decimals);
}

function isAllowed(value, decimals) {
  value = toStr(value);

  if (firstLattersReg.test(value)) return false;

  // TODO: @danealton разработать способ динамически создавать регулярное выражение
  switch (decimals) {
    case 2:
      return value ? /^\d+[,.]?\d{0,2}$/.test(value) : true;
    case 6:
      return value ? /^\d+[,.]?\d{0,6}$/.test(value) : true;
    case 8:
      return value ? /^\d+[,.]?\d{0,8}$/.test(value) : true;
  }
}

function toStr(value) {
  return value ? value.toString() : '';
}

function addThousandSeparator(integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`);
}

export { format };
